import { generateUrlBase } from "../../../utils/utils";
import type { ApiCallerT } from "./types";
import type {
  PeriodTypesApiT,
  GetAllPeriodTypesResponseT,
} from "../types/periodTypes.types";

export const createPeriodTypesApi = (
  apiCaller: ApiCallerT,
): PeriodTypesApiT => ({
  getAll: async () => {
    const url = generateUrlBase("periods/types");

    const response = await apiCaller<GetAllPeriodTypesResponseT>(
      url,
      "GET",
      {},
      {},
      {},
    );

    return response;
  },

  import: async (body) => {
    const url = generateUrlBase("periods/import");

    const response = await apiCaller<GetAllPeriodTypesResponseT>(
      url,
      "PUT",
      body,
      {},
      {},
    );

    return response;
  },
});
